var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('definition-form',{attrs:{"title":"definitions.edit","initialData":_vm.model,"mode":"edit"},on:{"save":_vm.save,"cancel":_vm.cancel}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }